module.exports = __webpack_public_path__ + "static/img/rapid.67817c04.png";